import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface IEmbossedDataFormMeta {
    
    // Embossed Data
    lig0Format: FormInputMeta;
    lig1Format: FormInputMeta;
    lig2Format: FormInputMeta;
    lig3Format: FormInputMeta;
    lig4Format: FormInputMeta;
}
const embossedDataFormMeta = {} as IEmbossedDataFormMeta;

// Embossed Data Form Fields
embossedDataFormMeta.lig0Format = {
    name: "lig0Format",
    type: "select",
    label: "Format Lig.0",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

embossedDataFormMeta.lig1Format = {
    name: "lig1Format",
    type: "select",
    label: "Format Lig.1",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

embossedDataFormMeta.lig2Format = {
    name: "lig2Format",
    type: "select",
    label: "Format Lig.2",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

embossedDataFormMeta.lig3Format = {
    name: "lig3Format",
    type: "select",
    label: "Format Lig.3",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

embossedDataFormMeta.lig4Format = {
    name: "lig4Format",
    type: "select",
    label: "Format Lig.4",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

export default embossedDataFormMeta;